import { css } from "@emotion/react"
import { Heading } from "@planningcenter/doxy-web"
import { Link } from "source/notifications/NotificationShow"
import PlannedGivingSummary from "./components/PlannedGivingSummary"
import { useDonationsSummaryContext } from "../hooks/useDonationSummaryContext"
import DonationsSummary from "./components/DonationsSummary"
import GivingProfileLinks from "./components/GivingProfileLinks"
import { NotifyNativeLoaded } from "source/shared/hooks/useNotifyNativeLoaded"
import NativeHeader from "source/shared/NativeHeader"

export default function Overview() {
  const { donationsSummary } = useDonationsSummaryContext()

  return (
    <>
      <NativeHeader title="Overview" />
      <section>
        <div className="d-f fd-c g-2">
          <div className="d-n d-f@md">
            <Heading level={1} size={2} text="Overview" />
          </div>
          <div className="d-f fd-c g-2">
            {donationsSummary && (
              <div
                className="d-f fd-c g-2 p-2"
                css={css`
                  border: 1px solid var(--color-tint6);
                  border-radius: 8px;
                `}
              >
                <Heading level={2} size={3} text="Donation history" />
                <NotifyNativeLoaded />
                <DonationsSummary donationsSummary={donationsSummary} />
                <Link to="/giving/profile/donations" className="fs-13 fw-500">
                  View all history
                </Link>
              </div>
            )}
            <div
              className="d-f fd-c p-2 g-2"
              css={css`
                border: 1px solid var(--color-tint6);
                border-radius: 8px;
              `}
            >
              <div className="d-f jc-sb ai-c">
                <Heading level={2} size={3} text="Planned giving" />
                <Link
                  to="/giving/profile/planned"
                  className="btn outline-btn sm-btn"
                >
                  Manage
                </Link>
              </div>
              <PlannedGivingSummary />
              <Link to="/me/profile/payment-methods" className="fs-13 fw-500">
                Manage payment methods
              </Link>
            </div>
          </div>
        </div>
      </section>
      <GivingProfileLinks />
    </>
  )
}
